import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';
import { authApi } from '../../api/auth';
import { useAuth } from '../../hooks/useAuth';
import { useToast } from '../../hooks/useToast';
const schema = z.object({ email: z.string().email('Invalid email'), password: z.string().min(1, 'Password required') });
type FormData = z.infer<typeof schema>;
const Login: React.FC = () => {
  const navigate = useNavigate(); const { login } = useAuth(); const { showToast } = useToast();
  const [loading, setLoading] = useState(false);
  const { register, handleSubmit, formState: { errors } } = useForm<FormData>({ resolver: zodResolver(schema) });
  const onSubmit = async (data: FormData) => {
    setLoading(true);
    try {
      const res = await authApi.login(data);
      const { token, user, company_id, branch_id } = res.data.data;
      login(token, user, company_id, branch_id);
      showToast('Welcome back, ' + user.name);
      navigate('/dashboard');
    } catch (err: any) { showToast(err.response?.data?.message || 'Login failed', 'error'); }
    finally { setLoading(false); }
  };
  return (
    <div className="auth-layout">
      <div className="auth-card">
        <div className="auth-logo">KLIK OPS</div>
        <div className="auth-title">Sign in to your account</div>
        <div className="auth-subtitle">Enter your credentials to continue</div>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="form-group">
            <label className="form-label">Email</label>
            <input className="form-control" type="email" placeholder="you@company.com" {...register('email')} />
            {errors.email && <div className="form-error">{errors.email.message}</div>}
          </div>
          <div className="form-group">
            <label className="form-label">Password</label>
            <input className="form-control" type="password" placeholder="••••••••" {...register('password')} />
            {errors.password && <div className="form-error">{errors.password.message}</div>}
          </div>
          <button type="submit" className="btn btn-primary" style={{ width: '100%', justifyContent: 'center', marginTop: 8 }} disabled={loading}>
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
        <div style={{ marginTop: 16, textAlign: 'center', fontSize: 12, color: 'var(--tx3)' }}>
          Don't have an account? <Link to="/register" style={{ color: 'var(--blue)', fontWeight: 600 }}>Register</Link>
        </div>
      </div>
    </div>
  );
};
export default Login;
